import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { HeaderFactory } from '../../common/HeaderFactory';

declare const OUTCOMES_API: string;

@Injectable()
export class SystemLockService {
    constructor(
        private http: Http,
        private headerFactory: HeaderFactory
    ) {
        //
    }

    unlockSystem(institutionId: number): Observable<any> {
        const obseravable = this.http.delete(OUTCOMES_API + '/system/unlock/' + institutionId, {
            headers: this.headerFactory.make()
        });

        return obseravable;
    }
}


/** WEBPACK FOOTER **
 ** ./app/system/services/SystemLockService.ts
 **/